/**
 * @file Auth0 SPA SDK provider — login callback must be `/login` (not `/`) so OAuth query params survive.
 */
import { Auth0Provider } from "@auth0/auth0-react";
import type { ReactNode } from "react";
import { getAuth0ClientId, getAuth0Domain, getSsoApiAudience, SSO_AUTH0_SCOPE, ssoAppOrigin } from "./sso-env";

export function Auth0SsoProvider({ children }: { children: ReactNode }) {
  const domain = getAuth0Domain()!;
  const clientId = getAuth0ClientId()!;
  const audience = getSsoApiAudience()!;
  const redirectUri = `${ssoAppOrigin()}/login`;

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience,
        scope: SSO_AUTH0_SCOPE,
      }}
      cacheLocation="localstorage"
      useRefreshTokens={false}
      onRedirectCallback={() => {
        // LoginRedirect navigates after Auth0 finishes. Avoid history.replaceState here.
      }}
    >
      {children}
    </Auth0Provider>
  );
}
